export default {"src":"/_next/static/media/reebelo.e99dc13d.svg","height":82,"width":82,"blurWidth":0,"blurHeight":0};